<template>
  <ProductSlider
    v-if="lookList?.product?.url"
    :products="lookItems"
    class="pdp__slider pdp__looks-slider"
    :settings="{ wrapAround: false }"
    :breakpoints="{}"
    :custom-settings="carouselSettings"
  >
    <div
      class="pdp-slider__heading heading"
      v-text="$t('Shop the look')"
    />

    <div
      class="pdp-slider__title"
      v-text="$t('This look consists of {count} items', { count: lookItems.length })"
    />
    <ProductShopTheLookTile
      :product="lookList.product"
      class="pdp-slider__pre-tile"
    />

    <template #slide>
      <div
        class="pdp-slider__slide-tile"
      >
        <ProductShopTheLookTile
          :product="lookList.product"
          class="pdp-slider__slide-tile"
        />
      </div>
    </template>
  </ProductSlider>
</template>

<script lang="ts" setup>
const props = defineProps<{
  currentProduct: object
  lookList?: object
}>()

const { breakpoint } = useApp()
const showLookInSlider = ref(true)

const lookItems = computed(() => {
  const items = [props.currentProduct, ...(props.lookList?.items?.map((item: any) => item?.product) || [])]
  return items.sort((a, b) => (b?.finalPrice || 0) - (a?.finalPrice || 0))
})

const carouselSettings = {
  itemsToShow: 1.3,
  itemsToScroll: 1,
  snapAlign: 'start',
  breakpoints: {
    560: {
      itemsToShow: 2.4,
    },
    768: {
      itemsToShow: 3,
    },
    1024: {
      itemsToShow: 3,
    },
  },
}

onMounted(() => {
  watchEffect(() => {
    showLookInSlider.value = ['mobile', 'phablet', 'tablet'].includes(breakpoint.value)
  })
})
</script>

<style>
  @import url("~layers/app/components/Product/ShopTheLookSlider.css");
</style>
